import React, { useCallback } from "react";

import { NavWrapper } from "../assets/styles/nav";

import Logo from "../assets/images/logo.png";

const Nav = () => {
    const goToIndexPage = useCallback(() => {
        window.location.href = '/';
    }, []);

    return (
        <NavWrapper>
            <img src={Logo} alt="logo" onClick={goToIndexPage} />
            <div>
                <a href={process.env.GATSBY_NAVER_LOUNGE_URL}>커뮤니티</a>
                <a href="/coupon">쿠폰입력</a>
                <a href={process.env.GATSBY_YOUTUBE_CHANNEL_URL}>미디어</a>
            </div>
        </NavWrapper>
    );
};

export default Nav;
